// extracted by mini-css-extract-plugin
module.exports = {"defaultStyle":"auto-resize-text-area_defaultStyle__1iLN2"};